module.exports = __webpack_public_path__ + "static/media/ost.ea7d89fc.svg";